import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import {NavProductos} from './NavProductos';

export class Header extends React.Component {
	render(){
		return <header class="first-header">					
					<nav class="navbar navbar-expand-lg navbar-light">
					
						
						<div class="collapse navbar-collapse justify-content-end mobileNavScroll" id="navbarNav">
							
							<ul class="nav-productos-lb displaynone-desktop">
								<li class="nav-item">
									<NavLink className="topScroll"  to="/arandelas">Arandelas</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/bulones">Bulones</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" exact={true} to="/">Tornillos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/tuercas">Tuercas</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-roscados-varios">Elementos roscados varios</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/accesorios-hidraulica-neumatica">Accesorios hidraulica/neumatica</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-sujecion-fijacion">Elementos de sujecion/fijacion</NavLink>
								</li>


								<li class="nav-item">
									<NavLink className="topScroll" to="/grampas-ganchos">Grampas/Ganchos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-de-corte">Elementos de corte y abrasión</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/herramientas-accesorios">Herramientas/accesorios</NavLink>
								</li>

								<li class="nav-item">
									<NavLink className="topScroll" to="/productos-quimicos">Productos quimicos</NavLink>
								</li>
								
								<li class="nav-item">
									<NavLink className="topScroll" to="/bulones-automotor">Bulones automotor</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-de-seguridad">Elementos de seguridad</NavLink>
								</li>

								<li class="nav-item">
									<NavLink className="topScroll" to="/herramientas-automotor">Herramientas de automotor</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/soldadura">Soldadura</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/clavos-alambres">Clavos y alambres</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/pegamentos">Pegamentos</NavLink>
								</li>
							</ul>



							<ul class="navbar-nav ap-nav">
								<li class="nav-item li-item li-section-header-link">
									<NavLink activeClassName={"active"} exact={true} to="/quienes-somos">Quienes somos</NavLink>
								</li>
								<li class="nav-item li-item li-section-header-link">
									<NavLink activeClassName={"active"} to="/ubicacion">Ubicación</NavLink>
								</li>
								<li class="nav-item li-section-header-link">
									<NavLink activeClassName={"active"} to="/contactos">Contacto</NavLink>
								</li>
							</ul>
				    		
						</div>
					</nav>
				</header>;
	}
} 


// WEBPACK FOOTER //
// ./src/components/Header.js